/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        20/02/2020 08:18
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import "slick-carousel/slick/slick.min";
import "jquery-match-height/dist/jquery.matchHeight-min";
import Modernizr from 'modernizr';
import WpetList from "./list";
import Ux from '../services/ux';

export default class WpetTrip {
    
    constructor()
    {
        WpetTrip.initializeTrip();
    }
    
    static initializeTrip()
    {
        /* WPET Trip (Sur place)
         /* ============================================= */
        if ( $( '.js-wpetTrip' ).length ) {
            
            // let to "reset list" or "back page" on mobile
            let action_list = "back";
            
            // Size mobile screen
            let mobile_screen = "650";
            
            // Min height agenda item
            $( '.js-mh' ).matchHeight();
            
            // Init slider event
            let js_slider_agenda = $( '.js-slide-event' ).slick( {
                                                                     slide: '.wpetTripItemContent',
                                                                     slidesToShow: 2,
                                                                     slidesToScroll: 1,
                                                                     letiableWidth: false,
                                                                     infinite: false,
                                                                     responsive: [
                                                                         {
                                                                             breakpoint: mobile_screen,
                                                                             settings: "unslick"
                                                                         }
                                                                     ],
                                                                 } );
            
            // Init slider thmatics
            let js_slider_thematics = $( '.js-slide-thematics' ).slick( {
                                                                            slide: '.wpetTripThematicsItem',
                                                                            slidesToShow: 9,
                                                                            swipe: false,
                                                                            responsive: [
                                                                                {
                                                                                    breakpoint: 1750,
                                                                                    settings: {
                                                                                        slidesToShow: 8,
                                                                                    }
                                                                                },
                                                                                {
                                                                                    breakpoint: 1600,
                                                                                    settings: {
                                                                                        slidesToShow: 7,
                                                                                    }
                                                                                },
                                                                                {
                                                                                    breakpoint: 1450,
                                                                                    settings: {
                                                                                        slidesToShow: 6,
                                                                                    }
                                                                                },
                                                                                {
                                                                                    breakpoint: 1300,
                                                                                    settings: {
                                                                                        slidesToShow: 5,
                                                                                    }
                                                                                },
                                                                                {
                                                                                    breakpoint: 1150,
                                                                                    settings: {
                                                                                        slidesToShow: 4,
                                                                                    }
                                                                                },
                                                                                {
                                                                                    breakpoint: mobile_screen,
                                                                                    settings: {
                                                                                        swipe: true,
                                                                                        slidesToShow: 2,
                                                                                        slidesToScroll: 2,
                                                                                        swipeToSlide: true,
                                                                                        centerMode: true,
                                                                                        centerPadding: '20px',
                                                                                        arrows: false,
                                                                                        infinite: true,
                                                                                        speed: 500,
                                                                                    }
                                                                                },
                                                                            ]
                                                                        } );
            
            // Display modal event
            $( '.js-trigger-modal-agenda' ).on( 'click', function () {
                
                $( '#modal-agenda .modal-body' ).html( Theme.translate.loading );
                
                $.ajax( {} );
                
                $.ajax( {
                            type: 'POST',
                            url: Theme.tripModalAgenda,
                            data: {
                                id: $( this ).data( 'id' )
                            },
                            dataType: 'json',
                            success: function ( response ) {
                                $( '.modal [data-wpet-trip="single"] [data-wpet-trip="singlemap"]' ).remove();
                                $( '#modal-agenda .modal-body' ).html( response.template );
                        
                                window.IRIS.wpet_trip.initializeSingleMap( response.post );
                            }
                        } );
            } );
            
            // Click to hide notification
            $( '[data-wpet-trip="resetNotification"]' ).bind( 'click', function () {
                $( '.js-notification' ).fadeOut();
            } );
            
            $( document ).on( 'wpet-trip-map-ready', function () {
                
                window.IRIS.wpet_trip.strokeColor = '#F76C1C';
                window.IRIS.wpet_trip.iconUser    = Theme.themeURL + '/assets/dist/images/markers/marker-user.png';
                window.IRIS.wpet_trip.iconOffice  = Theme.themeURL + '/assets/dist/images/markers/marker-user.png';
            } );
            
            // Click to show loader
            $( '.wpetTripThematicsItem' ).bind( 'click', function () {
                $( '.wpetTripSectionOffersMapLoader' ).fadeIn();
            } );
            
            // Modal display
            $( '#modal-wpet' ).on( 'shown.bs.modal', ( e ) => {
                
                Ux.initializeBootstrapPopover();
                
                setTimeout( function () {
                    
                    // Disable zoom on scroll
                    window.IRIS.wpet_trip.mapAdapter.map.scrollWheelZoom.disable();
                    
                    window.IRIS.wpet_trip.singleMap.resize();
                }, 500 );
            } );
            
            // List display | bind this
            $( window ).on( 'wpet-trip-list-ready', ( event, data ) => {
                
                // Show List
                $( '.js-wpetTripSectionOffersList' ).addClass( 'wpetTripSectionOffersList--visible' );
                $( '.wpetTripSectionOffersMapLoader' ).fadeOut();
                
                WpetList.initializeSlick();
                Ux.initializeLazy();
                
                // Hide bouton notification
                $( '.js-notification' ).fadeOut();
                
                // Show reset current thematic
                $( '.js-reset' ).fadeIn();
                
                // Load tooltip
                if ( !Modernizr.touch ) {
                    $( '[data-toggle="tooltip"]' ).tooltip();
                    $( '[rel="tooltip"]' ).tooltip();
                }
                
                // Open modal click marker
                $( document ).bind( 'wpet-single-open', function () {
                    $( '#modal-wpet' ).modal( 'show' );
                } );
                
                // Resize map
                setTimeout( () => {
                    WpetTrip.size_map();
                }, 500 );
                
                // No offer
                if ( $( '[data-wpet-trip="list"]' ).is( ':empty' ) ) {
                    $( '[data-wpet-trip="list"]' ).html( "<p class='wpetTripSectionOffersList--noOffer'>" + Theme.translate.noOffer + "</p>" );
                }
                
                // Touch screen (not mobile)
                if ( (Modernizr.touch) && (window.matchMedia( "(min-width: " + mobile_screen + "px)" ).matches) ) {
                    
                    $( '.js-trigger-map' ).bind( 'click', function ( e ) {
                        
                        let id = $( this ).closest( '[data-wpet-trip="offer"]' ).attr( 'data-wpet-trip-offer' );
                        
                        // Run distance
                        $( '[data-wpet-trip]' ).trigger( 'inactive' );
                        $( '[data-wpet-trip-offer="' + id + '"]' ).trigger( 'active' );
                        
                        window.IRIS.wpet_trip.currentData[ id ].setIcon( window.IRIS.wpet_trip.mapAdapter.options.options.markerhover );
                        e.stopPropagation();
                    } );
                }
                
                // Slider offer mobile only
                if ( window.matchMedia( "(max-width: " + mobile_screen + "px)" ).matches ) {
                    
                    $( '.wpetTripContentThematics' ).hide();
                    
                    let js_slider_list = {
                        slide: '[data-wpet-trip="offer"]',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        centerMode: true,
                        centerPadding: '20px',
                        arrows: false,
                        speed: 300,
                    };
                    
                    $( '[data-wpet-trip="list"]' ).slick( js_slider_list );
                    
                    // if only 1 item
                    if ( $( '.wpetItem' ).length == 1 ) {
                        $( '[data-wpet-trip="list"]' ).slick( 'slickSetOption', 'centerMode', false, true );
                    }
                    
                    // Active / inactive trip offer
                    $( '[data-wpet-trip-offer]:not(.slick-cloned)' ).eq( 0 ).trigger( 'active' );
                    $( '[data-wpet-trip="list"]' ).on( 'beforeChange', function ( event, slick, currentSlide, nextSlide ) {
                        
                        $( '[data-wpet-trip-offer]:not(.slick-cloned)' ).eq( currentSlide ).trigger( 'inactive' );
                        $( '[data-wpet-trip-offer]:not(.slick-cloned)' ).eq( nextSlide ).trigger( 'active' );
                    } );
                    
                    // let "reset list"
                    action_list = "reset";
                    $( '.js-back-page a' ).text( $( '[data-wpet-trip="currentthematic"]' ).text() );
                }
            } );
            
            // Click to reset list | bind this
            $( document ).on( 'wpet-trip-reset-all', ( event, data ) => {
                
                // Hide List
                $( '.js-wpetTripSectionOffersList' ).removeClass( 'wpetTripSectionOffersList--visible' );
                
                // Show reset current thematic
                $( '.js-reset' ).hide();
                
                // Resize map
                setTimeout( () => {
                    WpetTrip.size_map();
                }, 500 );
                
                // Show thematics mobile only
                if ( window.matchMedia( "(max-width: " + mobile_screen + "px)" ).matches ) {
                    $( '.wpetTripContentThematics' ).show();
                }
                
                // let "back page
                if ( window.matchMedia( "(max-width: " + mobile_screen + "px)" ).matches ) {
                    action_list = "back";
                    $( '.js-back-page a' ).text( Theme.translate.desire );
                }
            } );
            
            // Distance - Time on Offer
            $( document ).bind( 'wpet-trip-distance', function ( e, data ) {
                
                if ( $( '[data-wpet-trip-offer="' + data.ID + '"] .duration' ).length === 0 ) {
                    
                    let distance = parseInt( data.response.route.distance );
                    if ( !isNaN(distance) ) {
                        if ( distance > 1000 ) {
                            distance = parseInt( data.response.route.distance / 1000 ) + ' km';
                        } else {
                            distance = data.response.route.distance + ' m';
                        }
                        $( '[data-wpet-trip-offer="' + data.ID + '"]' ).find( '.wpetItemContainerContentCity' ).append( '<span class="duration wpetItemContainerContentCityDuration">' + Theme.translate.wpet_trip_distance.replace( /{{(.*?)}}/g, distance ) + '</span>' );
                    } else {
                        $( '[data-wpet-trip-offer="' + data.ID + '"]' ).find( '.wpetItemContainerContentCity' ).hide();
                    }
                }
            } );
            
            // Mobile screen
            $( '[data-target]' ).bind( 'click', ( e ) => {
                let attr = $( e.currentTarget ).attr( "data-target" );
                $( '[data-attribut=' + attr + ']' ).addClass( 'modal-page-active' );
                
                if ( attr == 'thematics' ) {
                    
                    // Resize map
                    setTimeout( () => {
                        WpetTrip.size_map();
                    }, 500 );
                }
            } );
            
            // Back page onload
            $( '.js-back-page' ).bind( 'click', function () {
                
                if ( (action_list == "reset") && (window.matchMedia( "(max-width: " + mobile_screen + "px)" ).matches) ) {
                    window.IRIS.wpet_trip.resetAll();
                    action_list = "back";
                    $( '.js-back-page a' ).text( Theme.translate.desire );
                } else {
                    $( '[data-attribut]' ).removeClass( 'modal-page-active' );
                }
            } );
            
            $( '#modal-contact' ).on( 'shown.bs.modal', function () {
                $( '[name="emailprestataire"]' ).val( $( '[href="#modal-contact"]' )[ 0 ].dataset.email );
            } );
            
            $( '#modal-contact' ).on( 'hidden.bs.modal', function () {
                $( '[name="emailprestataire"]' ).val( '' );
            } );
        }
    }
    
    // Resize map
    static size_map()
    {
        let mapClass  = $( '.wpet-trip-map' );
        let widthmap  = mapClass.parent().css( 'width' );
        let heightMap = mapClass.parent().css( 'height' );
        mapClass.css( 'width', widthmap );
        mapClass.css( 'height', heightMap );
        
        window.IRIS.wpet_trip.mapObject.resize;
        window.IRIS.wpet_trip.mapObject.fitBounds( window.IRIS.wpet_trip.bounds );
    }
}